import $ from 'jquery'

export const init = async function (): Promise<void> {
  $('#js-contact-next').on('click', function () {
    $('.js-contact-additiona').slideToggle('slow')
    $(this).parent().remove()
  })
}
